import React from 'react'

import ReportTable from '../report_table'
import { formatReportDate, localeNumberFormatter } from '../helpers'

// port of cowebapp analytics/components/team/report_member_table.js
const MemberTableOrg = (props) => {

  const dateFormatter = (cell) => {
    return formatReportDate(cell, props.breakdown)
  }

  const dataIndication = () => {
    return (
      <div
        className="list-container text-center bg-white"
        style={{ padding: '10px' }}
      >
        <p className="m-0">
          No Activity Found
        </p>
      </div>
    )
  }

  const getTableData = () => {
    let tableData = []
    props.memberData.forEach((data) => {
      if (data.prospect_billable > 0 || data.ev_billable > 0 || data.ef_billable > 0 || data.js_widget_billable > 0 || data.data_pulse_billable > 0) {
        tableData.push(data)
      }
    })
    return tableData
  }

  const data = getTableData()

  const formatNumber = localeNumberFormatter('0')

  const baseColumnStyle = {
    width: '14.28%' // 7 columns
  }

  const columns = [
    {
      dataField: 'date',
      text: 'Date',
      formatter: dateFormatter,
      headerStyle: baseColumnStyle,
      style: baseColumnStyle,
    },
    {
      dataField: 'total',
      text: 'Total',
      formatter: formatNumber,
      headerStyle: baseColumnStyle,
      style: baseColumnStyle,
      align: 'right',
      sort: true,
      headerTitle: () => 'Total'
    },
    {
      dataField: 'ev_billable',
      text: 'Email Verifier',
      formatter: formatNumber,
      headerStyle: baseColumnStyle,
      style: baseColumnStyle,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Verifier'
    },
    {
      dataField: 'ef_billable',
      text: 'Email Finder',
      formatter: formatNumber,
      headerStyle: baseColumnStyle,
      style: baseColumnStyle,
      align: 'right',
      sort: true,
      headerTitle: () => 'Email Finder'
    },
    {
      dataField: 'prospect_billable',
      text: 'Prospect',
      formatter: formatNumber,
      headerStyle: baseColumnStyle,
      style: baseColumnStyle,
      align: 'right',
      sort: true
    },
    {
      dataField: 'js_widget_billable',
      text: 'Form Guard',
      formatter: formatNumber,
      headerStyle: baseColumnStyle,
      style: baseColumnStyle,
      align: 'right',
      sort: true
    },
    {
      dataField: 'data_pulse_billable',
      text: 'Data Pulse',
      formatter: formatNumber,
      headerStyle: baseColumnStyle,
      style: baseColumnStyle,
      align: 'right',
      sort: true
    }
  ]

  return (
    <div>
      <ReportTable
        wrapperClasses="table-member-report table-responsive"
        keyField="date"
        data={data}
        columns={columns}
        noDataIndication={dataIndication}
        hideHeader
      />
    </div>
  )
}

export default MemberTableOrg
